import { HEADER_GROUP, useBookingRecoilValue, useNewNavigate } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { Center } from "@chakra-ui/react";
import { getDefaultParameters } from "@utils/getDefaultParameters";
import { CustomCenter, CustomSubText, CustomTitle } from "./deatilMenuBar.style";
import { type DetailMenuBarProps } from "./detailMenuBar.type";

export const DetailMenuBar = ({ navigation }: DetailMenuBarProps) => {
    const { onNavigate } = useNewNavigate();
    const { idx, co_id } = getDefaultParameters();
    const { isMobile } = MEDIA();
    const bookingEngine = useBookingRecoilValue();

    return (
        <CustomCenter
            overflow={isMobile ? "auto" : ""}
            flexDir="column"
            justifyContent={isMobile ? "flex-start" : "center"}
            rowGap="16px"
        >
            {HEADER_GROUP.map((header) => (
                <Center w="100%" key={header.title} flexDir="column">
                    <CustomTitle as="h4" key={header.title}>
                        {header.title}
                    </CustomTitle>
                    <Center w="50%" columnGap="12px" flexWrap="wrap">
                        {header.title === "Specials" &&
                            navigation?.specialList &&
                            navigation.specialList.map((special) => (
                                <CustomSubText
                                    onClick={() => onNavigate({ path: `/specials/${special.specialIdx}` })}
                                    key={special.specialIdx}
                                    p="12px 0"
                                >
                                    {special.specialName}
                                </CustomSubText>
                            ))}

                        {header.title === "Rooms" &&
                            navigation?.roomList &&
                            navigation.roomList.map((room) => (
                                <CustomSubText
                                    onClick={() => onNavigate({ path: `/rooms/${room.roomIdx}` })}
                                    key={room.roomIdx}
                                    p="12px 0"
                                >
                                    {room.roomName}
                                </CustomSubText>
                            ))}

                        {header.title === "Reservation" &&
                            header.contents.map((content, contentIndex) => {
                                const isCheck = content.title === "예약조회";

                                if (bookingEngine.isGoogleBE && isCheck && contentIndex === 1) {
                                    return null;
                                }

                                return (
                                    <CustomSubText
                                        onClick={() => {
                                            if (isCheck) {
                                                return window.open(
                                                    `https://calendar.marginauto.kr/bookingCheck?idx=${idx}&co_id=${co_id}`,
                                                    "_blank",
                                                );
                                            }

                                            // isReserve로 가드하면 구글 BE가 작동하지 않음
                                            // if (isReserve) {
                                            //     return window.open(
                                            //         `https://calendar.marginauto.kr/?idx=${idx}&co_id=${co_id}`,
                                            //         "_blank",
                                            //     );
                                            // }

                                            return window.open(bookingEngine.bookingUrl);
                                        }}
                                        key={content.title}
                                        p="12px 0"
                                    >
                                        {content.title}
                                    </CustomSubText>
                                );
                            })}

                        {header.title !== "Reservation" &&
                            header.title !== "Rooms" &&
                            header.title !== "Specials" &&
                            header.contents.map((content) => {
                                return (
                                    <CustomSubText
                                        onClick={() => onNavigate({ path: content.path })}
                                        key={content.title}
                                        p="12px 0"
                                    >
                                        {content.title}
                                    </CustomSubText>
                                );
                            })}
                    </Center>
                </Center>
            ))}
        </CustomCenter>
    );
};
